/**
 * Store Zustand para gerenciar filtros da aba Unidades
 */
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Regional, BrazilUF } from '@claro/shared';

export interface UnidadesFiltersState {
  // Filtros ativos
  regional: Regional | null;
  uf: BrazilUF | null;
  
  // Ações
  setRegional: (regional: Regional | null) => void;
  setUF: (uf: BrazilUF | null) => void;
  clearFilters: () => void;
  
  // Helpers
  hasActiveFilters: () => boolean;
  getFilterParams: () => Record<string, string>;
}

export const useUnidadesFilters = create<UnidadesFiltersState>()(
  devtools(
    (set, get) => ({
      // Estado inicial
      regional: null,
      uf: null,

      // Ações
      setRegional: (regional) => {
        set({ regional, uf: null }); // Limpa UF ao mudar regional
      },

      setUF: (uf) => {
        set({ uf });
      },

      clearFilters: () => {
        set({ regional: null, uf: null });
      },

      // Helpers
      hasActiveFilters: () => {
        const state = get();
        return state.regional !== null || state.uf !== null;
      },

      getFilterParams: () => {
        const state = get();
        const params: Record<string, string> = {};
        
        if (state.regional) params.regional = state.regional;
        if (state.uf) params.uf = state.uf;
        
        return params;
      },
    }),
    { name: 'unidades-filters' }
  )
);
